import {inject, Injectable} from '@angular/core';
import * as moment from "moment";
import {Delivery} from "../interfaces/delivery";
import {CookieService} from "./cookie.service";
import {LocalStorageService} from "./local-storage.service";
import {AccountData, Brand, userList} from "../interfaces/account-data";
import {BuGetBasket} from "../interfaces/bu-goods-data";
import {Currencies} from "../interfaces/currencies";
import {GoodsService} from "./goods.service";

// Валюта, в которой бэк считает корзину и заказ (priceEUR)
const EUR_CURRENCY_ID = 3;

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  private cookieService = inject(CookieService);
  private localStorage = inject(LocalStorageService);
  private goodsService = inject(GoodsService);

  constructor() {
  }

  buildDataMenu(data: AccountData, urlParams) {
    const categories = data.data.categories;
    const brands: Brand[] = Object.values(data.data.brands);
    const calcDebt = data.data.calcdebt;

    const deliveryInfo = Object.values(data.data.delivery_info).sort((a: Delivery, b: Delivery) => {
      const sortA = parseInt(a.sort);
      const sortB = parseInt(b.sort);

      if (sortA < sortB) {
        return -1;
      }
      if (sortA > sortB) {
        return 1;
      }

      return 0;
    });

    const brandsSorted = brands.sort((a, b) => {
      const sortA = parseFloat(a.allow_z_create);
      const sortB = parseFloat(b.allow_z_create);

      if (sortA < sortB) {
        return 1;
      }
      if (sortA > sortB) {
        return -1;
      }

      const nameA = String(a.name);
      const nameB = String(b.name);

      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }

      return 0;
    });

    const wars = data.data.wars;
    const isAdmin = data.data.is_admin;
    const allowLoginUsers = data.data.allow_login_users;
    let selectedUser = 'Користувач не вибраний';
    let warName = '';

    if (allowLoginUsers && allowLoginUsers.length) {
      selectedUser = this.cookieService.getCookie('email').replace('%40', '@');
      const user = allowLoginUsers.find(val => val.email == selectedUser);

      if (user) {
        selectedUser = `${user.fio} ${user.email}`;
      } else {
        selectedUser = 'Користувач не вибраний';
      }
    }
    //@ts-ignore
    const deliveryCurrent: Delivery = deliveryInfo.find((element: Delivery) => element.id == this.localStorage.get('delivery_id'));

    let selectedUserAdmin: string = '';
    let userListAdmin: userList[];

    if (isAdmin) {
      userListAdmin = data.data.userlist;

      // Вибраним показуємо того, кого бек реально підмінив (look_like_user), а не значення куки
      // admin_goods_look_like_user: кука може вказувати на того, кого бек не підміняє (адмін), і за нею
      // селектор показував чужий акаунт при власному балансі (#327)
      const lookLikeUser = data.data.look_like_user;

      if (lookLikeUser) {
        selectedUserAdmin = `${lookLikeUser.fio} ${lookLikeUser.email}`;
      }

      if (selectedUserAdmin === '') {
        selectedUserAdmin = 'Користувач не вибраний';
      }
    }

    if (deliveryCurrent) {
      warName = (deliveryCurrent.id != 2 && deliveryCurrent.id != 7) ? `, ${wars[1].name}` : '';
    }

    if (calcDebt.summa) {
      calcDebt.summaAbs = Math.abs(parseFloat(calcDebt.summa));
      //@ts-ignore
      calcDebt.summaUAHAbs = Math.abs(Math.ceil(parseFloat(calcDebt.summa) * parseFloat(Object.values(data.data.currencies).find((element: Currencies) => element.id == 3).rate || 0)));
    }

    if (calcDebt.summa_nalojki) {
      calcDebt.summaNalojkiAbs = Math.abs(parseFloat(calcDebt.summa_nalojki));
      //@ts-ignore
      calcDebt.summaNalojkiUAHAbs = Math.abs(Math.ceil(parseFloat(calcDebt.summa_nalojki) * parseFloat(Object.values(data.data.currencies).find(element => element.id == 3).rate || 0)));
    }

    let categoryId = urlParams.category_id;
    let brandId = urlParams.brand_id;
    let categoryHeadShow = '';
    let headCategoryNameColored = '';
    let subHeadCategoryName = '';
    let headCategoryName = '';

    // Дерево збираємо рекурсивно: у довіднику вже є 4-й рівень вкладеності
    // (розділ -> бренд -> категорія -> підкатегорія), а три вкладені цикли
    // обрізали все, що глибше третього, і такі категорії на сайт не потрапляли.
    const categoriesSorted = this.buildCategoryBranch(categories, 0);
    const selectedCategoryPath = this.findCategoryPath(categoriesSorted, categoryId);

    if (selectedCategoryPath.length) {
      const parentNames = selectedCategoryPath.slice(0, -1).map(category => category.name);

      headCategoryName = 'Головна';
      subHeadCategoryName = ' / ' + (parentNames.length ? parentNames.join(' / ') + ' / ' : '');
      headCategoryNameColored = selectedCategoryPath[selectedCategoryPath.length - 1].name;

      if (selectedCategoryPath.length === 1) {
        categoryHeadShow = selectedCategoryPath[0].name;
      }
    }

    if (brandId && brandId !== 0) {
      const selectedBrand = brandsSorted.find(brand => brand.id == brandId);

      if (selectedBrand) {
        if (!categoryId || categoryId === 0) {
          headCategoryName = 'Головна';
          subHeadCategoryName = ' / ' + 'Бренд' + ' / ';
          headCategoryNameColored = selectedBrand.name;
          categoryHeadShow = selectedBrand.name;
        } else {
          headCategoryName = 'Головна';
          subHeadCategoryName = ' / ' + 'Бренд' + ' / ' + selectedBrand.name + subHeadCategoryName;
        }
      }
    }

    if (urlParams.search != '') {
      headCategoryName = 'Головна';
      subHeadCategoryName = '';
      headCategoryNameColored = 'Результат пошуку за запитом: ' + urlParams.search;
    } else if (categoryId === 0 && (!brandId || brandId === 0)) {
      headCategoryName = '';
      headCategoryNameColored = 'Головна';
      subHeadCategoryName = '';
    }

    if (urlParams.receipt_date != '') {
      headCategoryName = 'Головна';
      subHeadCategoryName = ' / ';
      headCategoryNameColored = 'Надходження від: ' + moment(urlParams.receipt_date).format('DD.MM.YYYY');
    }

    return {
      categoriesSortedDeep: categoriesSorted,
      brandsSorted,
      selectedUserAdmin,
      selectedUser,
      warName,
      headCategoryNameColored,
      subHeadCategoryName,
      headCategoryName,
      userListAdmin,
      deliveryInfo,
      deliveryCurrent,
      categoryHeadShow,
      calcDebt
    }
  }

  // Гілка дерева категорій для заданого батька — рекурсивно, без обмеження глибини.
  // Порядок усередині гілки — за полем sort, як і раніше.
  private buildCategoryBranch(categories, parentId) {
    const branch = [];

    for (let category of categories) {
      if (category.parent_id != parentId) {
        continue;
      }

      category.values = this.buildCategoryBranch(categories, category.id);
      category.isOpenCategory = false;

      const indexSort = branch.findIndex(sort => parseInt(sort.sort) > parseInt(category.sort));

      if (indexSort !== -1) {
        branch.splice(indexSort, 0, category);
      } else {
        branch.push(category);
      }
    }

    return branch;
  }

  // Шлях від кореня гілки до категорії включно; порожній масив, якщо не знайдено.
  // З нього збираються хлібні крихти на будь-якому рівні вкладеності.
  findCategoryPath(branch, categoryId) {
    if (!categoryId || !branch) {
      return [];
    }

    for (let category of branch) {
      if (category.id == categoryId) {
        return [category];
      }

      const childPath = this.findCategoryPath(category.values, categoryId);

      if (childPath.length) {
        return [category, ...childPath];
      }
    }

    return [];
  }

  // Галочка строки на странице корзины (basket.turned_on): выключенные строки не идут в заказ,
  // поэтому виджет не считает их ни в сумме, ни в количестве. Бэк отдаёт "0"/"1" строкой.
  private isBasketRowTurnedOn(row): boolean {
    return Number(row.turned_on) === 1;
  }

  buildBasketData(data, currency_id) {
    let currencies = data.currencies;
    const suppliers = data.suppliers;
    const basketData = Array.isArray(data.basket_data)
      ? data.basket_data.filter(row => this.isBasketRowTurnedOn(row))
      : data.basket_data;
    let basketCount= 0;

    if (basketData) {
      basketCount = basketData.reduce((acc, current) =>
          acc + parseInt(current.count),
        0);
    }
    // @ts-ignore
    const currencyName = Object.values(currencies).find((element: Currencies) => element.id == parseInt(currency_id)).name;

    // Сумма — как на странице корзины (basket_data/data): цены строк в EUR × количество, в валюту кабинета
    // переводим один раз от итога. Сложение уже переведённых и округлённых вверх цен строк давало
    // лишнюю копейку (5247.21 против 5247.20 UAH, #386). Округление до копейки — toFixed(2) у вызывающих.
    let basketSumEUR = 0;

    if (basketData) {
      basketSumEUR = basketData.reduce((acc, current) => {
        let sup;

        if (current.zak_supp_id != 0) {
          sup = suppliers.find(element => element.alias == "partner_" + current.zak_supp_id);
        } else if (current.warehouse == 1) {
          sup = suppliers.find(element => element.alias == "w1");
        } else if (current.warehouse == 7) {
          sup = suppliers.find(element => element.alias == "w7");
        }

        if (!sup) {
          return acc;
        }

        // Оферты поставщика по строке нет (партнёр выключен, остатка нет — бэк отдал partner_N_* = null
        // или колонок нет вовсе): строку не считаем в сумме, как недоступную на странице корзины.
        // Тот же признак, что в goodsService.buildData.
        if (current[sup.alias + '_currency_id'] == null) {
          return acc;
        }

        // Цена — только готовая с бэка (priceEUR склада, partner_N_price_eur подзаказной строки):
        // без неё rowPrice даёт null, строка недоступна и в сумму не попадает.
        const res = this.goodsService.rowPrice(current, sup, currencies, EUR_CURRENCY_ID);

        if (res === null) {
          return acc;
        }

        return acc + parseInt(current.count) * res;
      }, 0);
    }

    const basketSum = parseInt(currency_id) == EUR_CURRENCY_ID
      ? basketSumEUR
      : basketSumEUR * parseFloat(currencies[EUR_CURRENCY_ID].rate) / parseFloat(currencies[currency_id].rate);

    return {
      basketCount,
      currencyName,
      basketSum
    };
  }

  buildBuBasketData(data: BuGetBasket) {
    const basketData = Array.isArray(data.data)
      ? data.data.filter(row => this.isBasketRowTurnedOn(row))
      : data.data;
    let basketCount = 0;

    if (basketData) {
      basketCount = basketData.reduce((acc, current) =>
          acc + parseInt(current.count),
        0);
    }

    let basketSum = 0;

    if (basketData) {
      basketSum = basketData.reduce((acc, current) =>
          acc + parseInt(current.count) * parseFloat(current.price),
        0);
    }

    return {
      basketCount,
      currencyName: 'UAH',
      basketSum
    };
  }
}
